/** Map backend/legacy Chinese messages to clear English for auth UI. */

const LEGACY = {
  账号不存在:
    'No account for this email. Sign up first, or check the address and try again.',
  密码错误: 'Wrong password. Try again or use Forgot password.',
  该邮箱已经被注册: 'This email is already registered. Sign in instead.',
  '验证码错误，请重新输入':
    'Incorrect verification code. Request a new code from email and try again.',
  请检查邮箱是否输入有误:
    'No account for that email. Check the address or create an account.',
  用户未登录: 'Please sign in to continue.',
  登录失败: 'Sign-in failed. Please try again.',
};

export function userFacingApiMessage(msg, fallback = 'Something went wrong. Please try again.') {
  if (msg == null || msg === '') return fallback;
  const s = String(msg).trim();
  if (!s) return fallback;
  return LEGACY[s] || s;
}
